var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup68236(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 60,
    viewBox: "0 0 160 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_68236",
    "data-name": "Group 68236",
    transform: "translate(-1305 -241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    transform: "translate(1305 241)",
    fill: "rgba(2,103,193,0.05)",
    stroke: "#0267c1",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 60,
    rx: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 158,
    height: 58,
    rx: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68225",
    "data-name": "Group 68225",
    transform: "translate(-32.374 11)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Button",
    transform: "translate(1427 266)",
    fill: "#0267c1",
    fontSize: 16,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21,
    y: 0
  }, "Go to")), /*#__PURE__*/React.createElement("g", {
    id: "arrow-backward",
    transform: "translate(1384 255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68224",
    "data-name": "Group 68224",
    transform: "translate(2.374 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39367",
    "data-name": "Path 39367",
    d: "M16.975,32.151,10.47,27v3.154h-.106c-8.673,0-7.977,8.5-7.977,8.5s.388-4.3,7.76-4.3h.323v3.049Z",
    transform: "translate(-2.374 -27)",
    fill: "#0267c1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup68236);
export default __webpack_public_path__ + "static/media/Group 68236.0f0e412583c0022c120a1f39c73464f6.svg";
export { ForwardRef as ReactComponent };